import React, { FC, useContext, useMemo } from 'react'
import { useTranslations } from 'next-intl'
import { useRouter } from 'next/router'
import style from './Copyright.module.css'
import { LanguageContext } from '../LanguageContext/LanguageContext'
import { LocaleContext } from '../LocaleContext/LocaleContext'
import { Languages } from '../../interfaces/common'
import { DIGITAL_PHONE } from '../../constants/phones'
import { CopyrightIcon } from './components/CopyrightIcon'
import { PhoneIcon } from './components/PhoneIcon'

const COPYRIGHT = 'app.footer.copyright'
const UZ_COPYRIGHT = 'app.footer.uzCopyright'
const COPYRIGHT_UZ_RU = 'app.footer.copyrightUZ'

const year = new Date().getFullYear()

interface ICopyrightProps {
  withoutPhone?: boolean
}

export const Copyright: FC<ICopyrightProps> = ({ withoutPhone }) => {
  const { query } = useRouter()
  const t = useTranslations()
  const { locale } = useContext(LocaleContext)
  const { language } = useContext(LanguageContext)

  const uzCopyright = locale === Languages.UZ ? COPYRIGHT_UZ_RU : COPYRIGHT
  const copyright = language === Languages.UZ ? UZ_COPYRIGHT : uzCopyright

  const digitalPhone = DIGITAL_PHONE[locale]

  const copyRightText = useMemo(() => {
    let text = `${t(copyright)}, ${year}`

    if (language === Languages.RU || language === Languages.KZ) {
      text += ' г.'
    }

    return text
  }, [t, copyright, language])

  return (
    <div className={style.copyright}>
      {!withoutPhone && !query.widget && (
        <span className={style.phone}>
          <PhoneIcon className={style.phoneIcon} />
          {digitalPhone}
        </span>
      )}
      <span className={style.copyrightText}>
        <CopyrightIcon className={style.icon} />
        {copyRightText}
      </span>
    </div>
  )
}

Copyright.displayName = 'Copyright'
